import axios from 'axios'
import Api from "./services/config/api/axios.urlcontext"

// APP_URL_API_EVOLUCION


// if(window.location.protocol === 'https:'){
//     const httpsagent = new https.Agent({
//         rejectUnauthorized : false
//     });

//     axios.defaults.httpAgent = httpsagent;
// }

const urlApis = {
    serverTramitesHacienda() {
      // console.log('serverTramitesHacienda___MODIFICADO');
        return  axios.create({ baseURL: Api.APP_URL_API_EVOLUCION+'/consumo_tramitesHacienda.php'})

    },
    serverAuthTramitesHacienda() {
        return  axios.create({ baseURL: Api.APP_URL_API_EVOLUCION+'/consumo_authHacienda.php'})
    },
    apiLogin(){
        return axios.create({ baseURL : 'http://200.57.183.210/SIFOSH/api/login/authenticate' })
    },
    apiFormatos(){
      // console.log(Api.APP_URL_API_PRESUPUESTO +'__');
      return axios.create({ baseURL : Api.APP_URL_API_PRESUPUESTO+'/SAF/api/formato' }) // <--produccion internet
        //return axios.create({ baseURL : 'http://200.57.183.210/SIFOSH/api/formato' }) // <-- pruebas
        //return axios.create({ baseURL : 'http://172.31.9.3/SAF/api/formato' }) // <--produccion intranet
        //unidades de apoyo->unidad de planeacion tiene resultados (interno)
        //tamb hay tramites externos
    },
    apiAuth(){
        return axios.create({ baseURL: Api.APP_URL_API_EVOLUCION+':8083/key/api/Auth'})
    }
}


// API
// http://200.57.183.210/sifosh/api/formato/formatosExternos
export default urlApis;
